import { render, staticRenderFns } from "./ArtistRow.vue?vue&type=template&id=464ef03f&scoped=true&"
import script from "./ArtistRow.vue?vue&type=script&lang=js&"
export * from "./ArtistRow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/listrows.css?vue&type=style&index=0&id=464ef03f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464ef03f",
  null
  
)

export default component.exports